import {checkRecordState} from "@/api/record-api";
import {mobileCheckRecordState} from "@/api/mobile/mobile-record-api";
import {getVisitorByBatch} from "@/api/visitor-api";

export class Visitor {

    constructor(data) {
        this.id = data.id;
        this.code = data.code;

        this.name = data.name;
        this.tel = data.tel;
        this.ic = data.ic; // 身份证
        this.company = data.company;
        this.nationality = data.nationality;
        this.email = data.email;
        this.car = data.car;
        this.tag = data.tag; // 护照

        this.head = data.head;
        this.address = data.address;
        this.comments = data.comments; // 备注
        this.cardNo = data.cardNo;

        this.type = data.type;
        this.usualTimeLimit = data.usualTimeLimit; // json字符串 表示常访时间限制
        this.contactEmployeeCode = data.contactEmployeeCode; // 常访对接员工code

        this.state = data.state;


        this.registerCardNo = "" // 登记给的卡号，外部传入, 签到使用，可以修改
        this.enterCardNo = "" // 签到时填的卡号， 外部传入
        this.arriveState = "" // 到访状态
        this.isMainVisitor = ""
        this.recordId = "" // 签到记录id

        this.showCardNo = "" // 显示的卡号
    }

    getShowArriveState() {
        if (this.arriveState === 'ENTER') {
            return '已签到'
        } else if (this.arriveState === 'LEAVE') {
            return '已签离'
        } else {
            return '未签到'
        }
    }

    isUsual() {
        return this.type === 'usual';
    }

    isBlack() {
        return this.type === 'black';
    }

    isProvider() {
        return this.type === 'provider';
    }
}

export class Employee {
    constructor(data) {
        this.id = data.id;
        this.code = data.code;
        this.loginName = data.loginName;
        this.loginPassword = data.loginPassword;
        this.defaultPassword = data.defaultPassword;

        this.topDepartmentId = data.topDepartmentId;
        this.departmentId = data.departmentId;
        this.departmentName = data.departmentName;
        this.roleType = data.roleType;
        this.roleValue = data.roleValue;
        this.name = data.name;
        this.tel = data.tel;
        this.head = data.head;
        this.workId = data.workId;
        this.email = data.email;
        this.title = data.title;
        this.age = data.age;
        this.sex = data.sex;
        this.state = data.state;
    }

}

export class FormItem {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.title = data.title;
        this.value = data.value;
        this.required = data.required;
        this.valueDefault = data.valueDefault;
        this.valueList = data.valueList;
    }
}

// create class Apply from json data
export class Apply {
    constructor(data) {
        this.id = data.id

        this.code = data.code
        this.visitor = new Visitor(data.visitor)
        this.visitorCardNo = data.visitorCardNo
        this.pinCode = data.pinCode ? data.pinCode : null
        this.pinVisitor = data.pinVisitor ? new Visitor(data.pinVisitor) : null


        this.employee = data.employee ? new Employee(data.employee) : {}
        this.type = data.type // SCENE_APPLY,
        this.device = data.device

        this.createTime = data.createTime
        this.beginDate = data.beginDate
        this.beginTime = data.beginTime
        this.endDate = data.endDate
        this.endTime = data.endTime

        this.accompanies = data.accompanies // 字符串， 同行人code列表，用'|'分隔
        this.accompanyList = [] // 同行人对象列表, 通过accompanies另行补全
        this.accompanyCards = data.accompanyCards ? data.accompanyCards : {}

        this.checkoutTime = data.checkoutTime

        this.forms = data.forms.map(item => new FormItem(item))

        this.entryArea = data.entryArea // 签到区域限制

        this.state = data.state
        this.arrived = data.arrived

        // for 员工
        this.flowId = data.flowId
        this.makeCopies = data.makeCopies  // str格式 抄送人id列表， 以 "|"  分割
        this.transferEmployeeId = data.transferEmployeeId
        this.related = data.related // 我的角色 ,以 "|"  分割

        this.totalSteps = data.totalSteps
        this.currentStep = data.currentStep
        this.currentEmployeeId = data.currentEmployeeId
        this.currentEmployeeCode = data.currentEmployeeCode
    }

    getShowFormList() {
        let result = []
        result.push({label: "开始时间", key: "startTime", value: this.beginDate + " " + this.beginTime})
        result.push({label: "结束时间", key: "endTime", value: this.endDate + " " + this.endTime})
        this.forms.forEach(item => {
            if (item.name === "startTime" || item.name === "endTime" || item.name === "accompany" || item.name === "peer") {
                return
            }
            result.push({label: item.title, key: item.name, value: item.value})
        })
        return result
    }



    async manageDoCheckRecordState(enterDate) {
        return await this._doCheckRecordState(enterDate,false)
    }

    async mobileDoCheckRecordState(enterDate) {
        return await this._doCheckRecordState(enterDate,true)
    }

    async _doCheckRecordState(enterDate, useMobile) {
        this.accompanyList = []
        let visitorCodeList = this.accompanies ? this.accompanies.split("|") : []
        visitorCodeList.push(this.visitor.code)
        try {
            let result
            if (useMobile) {
                result = await mobileCheckRecordState(this.id, visitorCodeList, enterDate)
            } else {
                result = await checkRecordState(this.id, visitorCodeList, enterDate)
            }
            console.log("checkRecordState result => ", result)
            if (result.data.code === 200) {
                result.data.data.forEach(item => {
                    let visitor = new Visitor(item)
                    visitor.isMainVisitor = item.code === this.visitor.code
                    visitor.arriveState = item.arriveState
                    visitor.recordId = item.recordId
                    if (visitor.isMainVisitor) {
                        visitor.registerCardNo = this.visitorCardNo
                    } else {
                        visitor.registerCardNo = this.accompanyCards[item.code]
                    }
                    visitor.enterCardNo = item.enterCardNo
                    this.accompanyList.push(visitor)
                })
            }
        } catch (err) {
            let visitor = this.visitor
            visitor.isMainVisitor = true
            visitor.registerCardNo = this.visitorCardNo
            this.accompanyList.push(visitor)
        }
        this.accompanyList.sort((a, b) => {
            if (a.isMainVisitor === b.isMainVisitor) {
                return 0;
            }
            return a.isMainVisitor ? -1 : 1;
        });
        console.log("checkRecordState accompanyList => ", this.accompanyList)
    }

    doCheckArea(localAreaId) {
        console.log("doCheckArea", localAreaId, this.entryArea)
        if (!localAreaId) {
            return true
        }
        if (!this.entryArea) {
            return false;
        }

        return localAreaId.toString() === this.entryArea.toString();
    }

    async manageGetShowVisitorList() {
        let result = []
        this.visitor.showCardNo = this.visitorCardNo
        result.push(this.visitor)
        if (this.accompanies) {
            let visitorCodeList = this.accompanies.split("|")
            let res = await getVisitorByBatch(visitorCodeList)
            if (res.data.code === 200) {
                res.data.data.forEach(item => {
                    let visitorObj = new Visitor(item)
                    visitorObj.showCardNo = this.accompanyCards[item.code]

                    result.push(new Visitor(item))
                })
            }
        }
        return result
    }
}


export class Record {
    constructor(data) {
        this.id = data.id
        this.type = data.type // USUAL,  UNIVERSAL,
        this.applyId = data.applyId
        this.apply = data.apply ? new Apply(data.apply) : null

        this.visitorId = data.visitorId
        this.visitor = data.visitor ? new Visitor(data.visitor) : null
        this.certPhoto = data.certPhoto

        this.employeeId = data.employeeId
        this.departmentId = data.departmentId
        this.topDepartmentId = data.topDepartmentId
        this.employee = data.employee ? new Employee(data.employee) : {}

        this.pinCode = data.pinCode

        this.related = data.related
        this.state = data.state
        this.exist = data.exist

        this.checkoutTime = data.checkoutTime
        this.confirmTime = data.confirmTime
        this.enterDate = data.enterDate
        this.enterTime = data.enterTime
        this.leaveDate = data.leaveDate
        this.leaveTime = data.leaveTime
        this.verifyMode = data.verifyMode

        this.completeState = data.completeState
        this.enterCardNo = data.enterCardNo
        this.enterCarNum = data.enterCarNum
        this.enterDeviceId = data.enterDeviceId
        this.leaveDeviceId = data.leaveDeviceId
        this.enterAreaId = data.enterAreaId
        this.leaveAreaId = data.leaveAreaId
        this.enterPhoto = data.enterPhoto
        this.leavePhoto = data.leavePhoto
        this.icCompareResult = data.icCompareResult
        this.icCompareScore = data.icCompareScore
        this.enterGuardName = data.enterGuardName
        this.leaveGuardName = data.leaveGuardName
        this.comments = data.comments
    }

}
